// extracted by mini-css-extract-plugin
module.exports = {"CoverImage":"styles_CoverImage__NE3RQ"};